import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
    Grid,
    makeStyles,
    Paper,
    Button,
    TextField,
    MenuItem,
    Grow
} from '@material-ui/core';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import axios from 'axios';
import * as requestHeaders from '../../../Constants/requestHeaders';

import * as lang from '../../../Constants/strings';

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(0, 0, 2, 0),
        width: 'auto'
    },
    fields: {
        margin: theme.spacing(1),
        borderRadius: '45px'
    },
    button: {
        margin: theme.spacing(2, 1, 1, 2),
        width: '98%',
    },
    checkbox: {
        margin: theme.spacing(1)
    },
    text: {
        margin: theme.spacing(2)
    }
}));

export default function SortBar(props) {
    const classes = useStyles();
    const { language } = props;
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [contractorList, setContractorList] = useState([]);
    const [selectedContractor, setSelectedContractor] = useState(null);

    const getContractors = async () => {
        try {
            const response = await axios.get('/api/get_executors', {
                ...requestHeaders.getGetHeader(),
                params: {
                    active: 1
                }
            });
            setContractorList(response.data)
        } catch (e) {
            setContractorList([]);
        }
    }

    const applyFilters = () => {
        props.filter({ startDate, endDate, selectedContractor });
    }

    const download = () => {
        props.onDownload({ startDate, endDate, selectedContractor })
    }

    useEffect(() => {
        getContractors();
    }, []);

    return (
        <Grow in={true} style={{ transitionDelay: true ? '100ms' : '0ms' }}>
            <Paper className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                className={classes.fields}
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                id="date-picker-inline-1"
                                label={lang.START_INTERVAL_DATE[language]}
                                value={startDate}
                                onChange={date => setStartDate(date)}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={2}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                className={classes.fields}
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                id="date-picker-inline-1"
                                label={lang.LAST_INTERVAL_DATE[language]}
                                value={endDate}
                                onChange={date => setEndDate(date)}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            required
                            select
                            className={classes.fields}
                            variant='outlined'
                            name='user'
                            label={lang.CONTRACTOR[language]}
                            onChange={(e) => setSelectedContractor(e.target.value)}
                            value={selectedContractor}
                            fullWidth
                        >
                            {
                                contractorList.map(contractor => <MenuItem key={contractor.OBJID} value={contractor.OBJID}>{contractor.NAME}</MenuItem>)
                            }
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            variant='contained'
                            color='primary'
                            disabled={selectedContractor === null}
                            className={classes.button}
                            onClick={() => applyFilters()}
                        >
                            {lang.FILTER[language]}
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            variant='contained'
                            color='primary'
                            disabled={selectedContractor === null}
                            className={classes.button}
                            onClick={download}
                        >
                            Download
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Grow>
    )
}
